import { Expandable } from '@warp-ds/react/components/expandable';
import type { PropsWithChildren, ReactNode } from 'react';

type FilterExpandableProps = {
    title: string | ReactNode;
    testId?: string;
    expanded?: boolean;
    className?: string;
};

export const FilterGroup = ({ title, testId, children, expanded = true, className = '' }: PropsWithChildren<FilterExpandableProps>) => (
    <Expandable
        box
        buttonClass="s-bg rounded-0"
        contentClass={`s-bg rounded-0 ${className}`}
        expanded={expanded}
        title={title}
        headingLevel={3}
        data-testid={testId}>
        {children}
    </Expandable>
);
